import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux'
import {NavLink, useLocation} from "react-router-dom";
import {createTheme, MuiThemeProvider} from "@material-ui/core/styles";
import {tableTheme} from "../../components/customTable/TableTheme";
import ActionsOptions from "../../components/customTable/ActionsOptions";
import ActionsWrapper from "../../components/customTable/ActionsWrapper";
import EditButton from "../../components/customTable/EditButton";
import DeleteButton from "../../components/customTable/DeleteButton";
import NavigateButton from "../../components/customTable/NavigateButton";
import SearchButton from "../../components/customTable/SearchButton";
import FilterButton from "../../components/customTable/FilterButton";
import {StaticTableOptions} from "../../components/customTable/StaticTableOptions";
import AddButton from "../../components/customTable/AddButton";
import {addDirectorateData, deleteDirectorateData, fetchDirectorateData, updateDirectorateData} from "../../store/directorate/directorateActions";
import MUIDataTable from "mui-datatables";
import DeleteDialog from "../../components/dialogs/DeleteDialog";
import AddDialog from "../../components/dialogs/AddDialog";
import DialogHeader from "../../components/dialogs/DialogHeader";
import TextInput from "../../components/textInput/TextInput";

function Directorates({ getMuiTheme = () => createTheme(tableTheme) }) {

    const dispatch = useDispatch()
    const language = useSelector(state => state.userInfos.language)
    const directorates = useSelector(state => state.directorates.directorates)
    const isDirectorate = useSelector(state=>state.directorates.isDirectorate)
    const TableOptions = useSelector(state => state.tableOptions.options)
    const [openAdd, setOpenAdd] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [openEdit, setOpenEdit] = useState(false)
    const [directorateId, setDirectorateId] = useState(false)

    const cancelAddRef = useRef(null)
    const cancelDeleteRef = useRef(null)

    const [directorate, setDirectorate] = useState({})

    const location = useLocation()
    const  { pathname } = location
    const url = pathname.split("/")
    const regionId = url[3]
    const cityId = url[5]
    const ministryId = url[7]

    const cols = [
        {
            name: "name",
            label: language.directorate_name,
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => {
                    return (
                        <NavLink to={`/admin/regions/${regionId}/cities/${cityId}/ministries/${ministryId}/directorates/${directorates[tableMeta.rowIndex].id}/corporations`}>{value}</NavLink>
                    );
                }
            }
        },
        {
            name: "",
            options: {
                ...ActionsOptions,
                customBodyRender: (value, tableMeta, rowIndex) => {
                    return (
                        <ActionsWrapper>
                            <EditButton
                                onClick={() => {
                                    setDirectorateId(directorates[tableMeta.rowIndex].id)
                                    setOpenEdit(true)
                                    setOpenAdd(true)
                                    setDirectorate(directorates[tableMeta.rowIndex])
                                }}
                            />
                            <DeleteButton
                                onClick={() => {
                                    setDirectorateId(directorates[tableMeta.rowIndex].id)
                                    setOpenDelete(true)
                                }
                                }
                            />
                            <NavigateButton navigate={`/admin/regions/${regionId}/cities/${cityId}/ministries/${directorates[tableMeta.rowIndex].id}/directorates`} />
                        </ActionsWrapper>
                    );
                }
            }
        }];

    const components = {
        icons: {
            SearchIcon: SearchButton,
            ViewColumnIcon: FilterButton,
        }
    }

    const options = {
        ...TableOptions, ...StaticTableOptions,
        selectableRows: "multiple",
        customToolbar: () => {
            return (
                <AddButton onClick={() => {
                    setOpenAdd(true)
                    setOpenEdit(false)
                }} />
            )
        }
    }

    const saveDirectorate = () => {
        dispatch(addDirectorateData(ministryId,directorate.name))
        setOpenAdd(false)
    }

    const deleteDirectorate = () => {
        dispatch(deleteDirectorateData(directorateId))
        setOpenDelete(false)
    }

    const editDirectorate = () => {
        dispatch(updateDirectorateData(directorateId, directorate.name))
        setOpenEdit(false)
        setOpenAdd(false)
    }

    useEffect(() => {
        dispatch(fetchDirectorateData(ministryId))
    }, [dispatch,isDirectorate])

    return (
        <div>
            <div className="container mt-3 px-3 mx-auto max-w-screen-lg data-table">
                <MuiThemeProvider theme={getMuiTheme()}>
                    <MUIDataTable
                        className="w-full z-0"
                        title={language.directorates}
                        data={directorates}
                        columns={cols}
                        options={options}
                        components={components}
                    />
                </MuiThemeProvider>
            </div>
            <DeleteDialog
                openDelete={openDelete}
                cancelDeleteRef={cancelDeleteRef}
                setOpenDelete={setOpenDelete}
                deleteItem={deleteDirectorate}
                title={language.delete_directorate}
                warning={language.directorate_delete_warning}
            />
            <AddDialog
                isEdit={openEdit}
                openAdd={openAdd}
                setOpenEdit={setOpenEdit}
                setOpenAdd={setOpenAdd}
                cancelAddRef={cancelAddRef}
                saveItem={saveDirectorate}
                editItem={editDirectorate}
            >
                <DialogHeader
                    closeModal={() => setOpenAdd(false)}
                    title={openEdit ? language.edit_directorate : language.add_directorate}
                />
                <TextInput
                    label={language.directorate_name}
                    value={openEdit ? directorate.name : null}
                    onChange={(e) => setDirectorate({ ...directorate, name: e.target.value })}
                    placeholder={language.directorate_name}
                />
            </AddDialog>
        </div>
    );
}

export default Directorates;